import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';

import { Checkbox } from '@bingads-webui-react/checkbox';
import { RadioGroup } from '@bingads-webui-react/radio';

import { stringKeys, actionOptions } from '../common/constants';

const ActionOptionGroupStyle = {
  marginLeft: 20,
};

export class ActionSelector extends React.PureComponent {
  static propTypes = {
    i18n: PropTypes.shape({
      getString: PropTypes.func.isRequired,
    }).isRequired,

    onActionRequirementChanged: PropTypes.func.isRequired,
    onActionSelectionChanged: PropTypes.func.isRequired,
  };

  state = {
    isActionRequired: false,
    actionSelection: actionOptions.noop,
  };

  onActionRequirementChanged = (event) => {
    const newActionRequirementValue = event.target.checked;

    this.setState({
      isActionRequired: newActionRequirementValue,
    });

    // Reset action selection if uncheck the action requirement checkbox
    if (newActionRequirementValue === false) {
      this.setState({
        actionSelection: actionOptions.noop,
      });
      this.props.onActionSelectionChanged(actionOptions.noop);
    }

    this.props.onActionRequirementChanged(newActionRequirementValue);
  }

  onActionSelectionChanged = (actionOption) => {
    this.setState({
      actionSelection: actionOption,
    });

    this.props.onActionSelectionChanged(actionOption);
  }

  render() {
    const actionSelectionGroup = (
      <RadioGroup
        checked={this.state.actionSelection}
        items={_.filter(_.values(actionOptions), x => x !== actionOptions.noop)}
        onChange={this.onActionSelectionChanged}
        name="customer-list-action-options"
        renderItem={item => this.props.i18n.getString(item.descriptionStringKey)}
      />
    );

    return (
      <div className="customer-list-action-selector">
        <Checkbox
          inline
          checked={this.state.isActionRequired}
          name="require-action-checkbox"
          onChange={this.onActionRequirementChanged}
        >
          {this.props.i18n.getString(stringKeys.editAudienceStatement)}
        </Checkbox>
        <div style={ActionOptionGroupStyle}>
          {
            this.state.isActionRequired ? actionSelectionGroup : null
          }
        </div>
      </div>
    );
  }
}
